// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"55fe692b","253":"dff2621d","284":"2d8fe6f9","453":"9ae2ae1b","973":"9717a097"}[chunkId] + ".chunk.js";
};